/* eslint-disable one-var */
export const Numpad0 = 'Numpad0';
export const Numpad1 = 'Numpad1';
export const Numpad2 = 'Numpad2';
export const Numpad3 = 'Numpad3';
export const Numpad4 = 'Numpad4';
export const Numpad5 = 'Numpad5';
export const Numpad6 = 'Numpad6';
export const Numpad7 = 'Numpad7';
export const Numpad8 = 'Numpad8';
export const Numpad9 = 'Numpad9';

export const Digit0 = 'Digit0';
export const Digit1 = 'Digit1';
export const Digit2 = 'Digit2';
export const Digit3 = 'Digit3';
export const Digit4 = 'Digit4';
export const Digit5 = 'Digit5';
export const Digit6 = 'Digit6';
export const Digit7 = 'Digit7';
export const Digit8 = 'Digit8';
export const Digit9 = 'Digit9';

export const Backspace = 'Backspace';
